module.exports = __webpack_public_path__ + "static/media/logo_white.9fa2f8ca.svg";